
import { createSelector } from 'reselect'

const getGroupList = state => state.member_details.groups

export const getIsEmptyGroupList = createSelector([getGroupList], groups => groups.length === 0)

export const getIsEmptyTagList = createSelector(
  state => state.member_details.tags,
  tags => tags.length === 0
)

export const makeGetTagsByGroup = () => {
  return createSelector(
    [
      state => state.member_details.tags,
      (state, props) => props.profile_details.customerGroup
    ],
    (tags, group) => tags.filter(tag => tag.group === group)
  )
}

export const makeGetCannedResponseByGroup = () => {
  return createSelector(
    [
      state => state.member_details.canned_responses,
      (state, props) => (props.active_chat_item && props.active_chat_item.group) ? props.active_chat_item.group : null
    ],
    (cn, group) => {
      if (group) {
        return cn.filter(c => c.hasOwnProperty('group') ? c.group === group : c)
      }
      return cn
    }
  )
}



// WEBPACK FOOTER //
// ./src/data/redux/member_details/selectors.js